import { render } from "./Footer.vue?vue&type=template&id=5c251c16&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5c251c16&scoped=true&lang=scss"
import "./Footer.vue?vue&type=style&index=1&id=5c251c16&lang=scss"

import exportComponent from "/Users/ecm1922/Code/jakob-schloer.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c251c16"]])

export default __exports__